import React from 'react';
import styled from 'styled-components';

import { formatTimestamp, def } from './utilities';
import { getEventAnnotationRenderer, EventAnnotation, EVENT_ANNOTATION_DIMENSIONS } from './EventAnnotations';
import { EventAnnotationTooltipProps } from './Tooltips';
import { Alert, DefaultAnnotationLabels, CriticalSeverity } from './constants';
import { VizTheme, useVizTheme } from './theme';

const StyledAnnotationContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const StyledAnnotationIconContainer = styled.div`
    margin-right: 10px;
    display: flex;
    align-items: center;
`;
const StyledAnnotationSeverityContainer = styled.div<{ theme: VizTheme }>`
    color: ${(props): string => props.theme.tooltip.color};
    margin-right: 10px;
    display: flex;
    align-items: center;
`;
const StyledAnnotationTriggeredContainer = styled.div<{ theme: VizTheme }>`
    color: ${(props): string => props.theme.tooltip.color};
`;
const StyledAnnotationTimeContainer = styled.div`
    color: #ccc;
    font-size: 12px;
    margin-bottom: 1;
`;
const StyledAnnotationDetailsContainer = styled.div`
    color: #ccc;
    font-size: 12px;
    margin-bottom: 1;
`;
const StyledAnnotationTooltip = styled.div<{ theme: VizTheme }>`
    border-radius: 5px;
    background-color: ${(props): string => props.theme.tooltip.backgroundColor};
    color: ${(props): string => props.theme.tooltip.color};
    margin: 0 5px;
    padding: 5px 10px;
    font-size: 14px;
    text-align: left;
`;

const CLICK_ANNOTATION_DETAILS_LABEL = 'Click on annotation for details';
export const BasicEventAnnotationTooltip: React.FC<EventAnnotationTooltipProps> = props => {
    const theme = useVizTheme();
    const locale = props?.userLocale;
    let formattedDate: React.ReactNode = null;
    if (props.eventAnnotationCursorState.time) {
        formattedDate = formatTimestamp(
            props.eventAnnotationCursorState.time * 1000,
            'dateVerboseTimePrecise',
            locale
        );
    }

    const onClickAnnotationEnabled = def(props.eventAnnotationConfig?.onEventAnnotationClick);
    const annotationRenderer = getEventAnnotationRenderer(props.eventAnnotationConfig);

    const getAnnotationInfoRow: React.FC<EventAnnotation> = eventAnnotationCursorState => {
        if (eventAnnotationCursorState.type === Alert) {
            return (
                <>
                    <StyledAnnotationSeverityContainer theme={theme}>
                        {DefaultAnnotationLabels[eventAnnotationCursorState.severity || CriticalSeverity]}
                    </StyledAnnotationSeverityContainer>
                    <StyledAnnotationIconContainer>
                        {annotationRenderer({
                            event: eventAnnotationCursorState,
                            theme,
                            dimensions: EVENT_ANNOTATION_DIMENSIONS,
                        })}
                    </StyledAnnotationIconContainer>
                    <StyledAnnotationTriggeredContainer theme={theme}>
                        1 triggered
                    </StyledAnnotationTriggeredContainer>
                </>
            );
        }
        return (
            <StyledAnnotationTriggeredContainer theme={theme}>
                {eventAnnotationCursorState.key}
            </StyledAnnotationTriggeredContainer>
        );
    };

    return (
        <StyledAnnotationTooltip theme={theme}>
            {formattedDate && <StyledAnnotationTimeContainer>{formattedDate}</StyledAnnotationTimeContainer>}
            <StyledAnnotationContainer>
                {getAnnotationInfoRow(props.eventAnnotationCursorState)}
            </StyledAnnotationContainer>
            {onClickAnnotationEnabled && (
                <StyledAnnotationDetailsContainer>
                    {CLICK_ANNOTATION_DETAILS_LABEL}
                </StyledAnnotationDetailsContainer>
            )}
        </StyledAnnotationTooltip>
    );
};
